module.exports = __webpack_public_path__ + "img/首页banner.872e5672.png";